// src/components/AuthTokenBridge.jsx
// Registers the live Clerk getToken function into apiClient's global
// registry so non-component modules (alertsApi.js, supabase.js) and
// far-away pages can send authenticated requests via apiFetch() without
// each one wiring useAuth() individually. Renders nothing. Mount once,
// as high in the tree as possible, inside whatever wraps the app with
// ClerkProvider.
import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { registerTokenGetter } from "../utils/apiClient";

export default function AuthTokenBridge() {
  const { getToken } = useAuth();
  useEffect(() => {
    registerTokenGetter(getToken);
  }, [getToken]);
  return null;
}